import * as yup from "yup";
import { number } from "yup";

export const priceSchema = yup.object({
  HighPricePKg: number(),
  PriceLowOfHigh: number(),
});
